<template>
  <div class="form-group">
    <span class="w-lbl" :for="id">{{ $t(lbl) }} <i v-if="required">&#42;</i></span>
    <input
      :ref="id"
      v-model="currentValue"
      :type="!!type ? type : 'text'"
      class="form-control"
      :class="{ 'has-error': error }"
      :data-test="id"
      :placeholder="placeholder"
      :title="title"
      :required="!!required"
      :autofocus="!!autofocus"
      :disabled="disabled"
      :maxlength="maxLength || 100"
      @input="onChange"
      @keydown.enter.prevent="
        () => {
          return false;
        }
      "
    />
    <div v-if="error" class="text-danger">
      <i class="fas fa-exclamation-triangle" />
      {{ $t(lbl_error) }}
    </div>
  </div>
</template>
<script>
export default {
  //form-group => :class="{'has-error' :lbl_error}"
  props: {
    id: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    },
    lbl: {
      type: String,
      default: undefined
    },
    lbl_error: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: undefined
    },
    autofocus: Boolean,
    required: Boolean,
    hasFocus: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: undefined
    },
    maxLength: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      currentValue: null
    };
  },
  computed: {
    error() {
      return !!this.lbl_error;
    }
  },
  watch: {
    value(val) {
      this.currentValue = val;
    }
  },
  mounted() {
    this.currentValue = this.value;
  },
  methods: {
    onChange() {
      this.$emit("input", this.currentValue);
    }
  }
};
</script>
<style scoped lang="scss">
.form-control.has-error {
  border: 2px solid #fc5c65;
}
</style>
